export const PRESS_TAP = { scale: 0.965, y: 1 };

export const SUBTLE_PRESS_TAP = { scale: 0.98, y: 1 };

export const PRESS_HOVER = { y: -1 };

export const PRESS_TRANSITION = {
  type: "spring",
  stiffness: 520,
  damping: 30,
  mass: 0.55,
};

export const LABEL_CROSSFADE_TRANSITION = {
  duration: 0.22,
  ease: [0.22, 1, 0.36, 1],
};
